<template>
  <h1
    v-if="level === '1'"
    :style="style"
  >
    <slot />
  </h1>
  <h2
    v-else-if="level === '2'"
    :style="style"
  >
    <slot />
  </h2>
  <h3
    v-else-if="level === '3'"
    :style="style"
  >
    <slot />
  </h3>
  <h4
    v-else-if="level === '4'"
    :style="style"
  >
    <slot />
  </h4>
</template>

<script>
export default {
  name: 'Heading',
  props: {
    level: {
      type: String,
      default: () => '1',
    },
    fontColor: {
      type: String,
      default: () => '#000000',
    },
    fontSize: {
      type: String,
      default: () => '48px',
    },
    fontWeight: {
      type: String,
      default: () => '400',
    },
    letterSpacing: {
      type: String,
      default: () => '-0.015em',
    },
    lineHeight: {
      type: String,
      default: () => '72px',
    },
  },
  data() {
    return {
      style: this.mountStyle(),
    };
  },

  created() {
    this.mountStyle();
  },

  methods: {
    verifyColor() {
      return this.$props.fontColor.includes('linear-gradient');
    },

    mountStyle() {
      const style = {
        color: this.$props.fontColor,
        'font-size': this.$props.fontSize,
        'font-weight': this.$props.fontWeight,
        'letter-spacing': this.$props.letterSpacing,
        'line-height': this.$props.lineHeight,
      };

      if (this.verifyColor()) {
        style.color = 'transparent';
        style['background-image'] = this.$props.fontColor;
        style['-webkit-background-clip'] = 'text';
        style['background-clip'] = 'text';
      }

      return style;
    },
  },
};
</script>
